const messages = {
  title: "Hinnakirjad ja tootebrošüürid",
  title_media: "Hinnakirjad ja tootebrošüürid",
  description:
    "Laadige alla uusimad brošüürid ja flaiereid Bridgestone ja Firestone rehvide kohta sõiduautode, SUV-de ja väikekandurite jaoks.",
  short_description:
    "Siit leiate materjale sotsiaalmeedia, poe-TV ja muu jaoks.",
  mediaCategories: {
    products: "Tooted",
    brand_and_solutions: "Bränd ja lahendused",
    season_and_promotions: "Hooaeg ja kampaaniad",
    format: "Formaat",
    cars_and_vans: "Sõiduauto, SUV, väikekaubik",
    truck_and_buses: "Veoauto ja buss",
    motorcycle: "Mootorratas",
    agriculture: "Põllumajandus",
    construction_machinery: "Ehitusmasinad",
    bridgestone: "Bridgestone",
    firestone: "Firestone",
    bandag: "Bandag",
    bleetcare: "Fleetcare",
    webfleet: "Webfleet",
    material: "Materjalid",
    brochures: "Tootebrošüürid",
    price_list: "Hinnakirjad",
    materials: "Materjalid",
    video_in_store: "Video subtiitritega",
    video_online: "Video ilma subtiitriteta",
    video: "Video",
    banner_website: "Bänner",
    banner_social_media: "Sotsiaalmeedia",
    logos: "Logod",
    summer: "Suvi",
    winter: "Talv",
    all_season: "Kõik hooajad",
    promotions: "Kampaaniad",
    price: "Pricat",
  },
  mediasPage: {
    title: "MEEDIAKOGU",
    description:
      "Tere tulemast Bridgestone ja Firestone   \n" +
      "toodetele pühendatud meedia sektsiooni.  \n <br> <br>" +
      "Avastate toote visuaale,   \n" +
      "logo, samuti laia valikut   \n" +
      "bannereid, videoid ja digitaalseid materjale   \n" +
      "kasutamiseks oma veebisaidil või   \n" +
      "sotsiaalmeedias.  ",
    bDrive: {
      title: "Toote fotod",
      description:
        "Praegused pildid   \n" +
        "saab alla laadida   \n" +
        "meie B-\n" +
        "DRIVE portaalist.  ",
    },
  },
  buttons: {
    media: "AVASTA",
  },
  searchMedia: "Sisesta märksõna",
  searchResults: "Otsingutulemused",
};

export default {
  messages,
};
